<!-- NewChatButton.svelte -->
<script>
    import { onMount } from 'svelte';
    import { db, activeConversation, userID, clientUserID, emailHash, } from "../stores.js";

    export let conversations;
    export let extraClass = ""; // Renamed prop to avoid reserved keyword




    function generateRandomId(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }

    function fetchConversations() {
    if ($userID && $clientUserID) {
        const conversationsRef = $db
            .collection("users")
            .doc($userID)
            .collection("deploymentUserData")
            .doc($clientUserID)
            .collection("clientSubUsers")
            .doc($emailHash)
            .collection("conversations");

        conversationsRef
            .orderBy("lastModified", "desc")
            .orderBy("timestamp", "desc")
            .onSnapshot(
                (snapshot) => {
                    let updatedConversations = [];

                    snapshot.docs.forEach((doc) => {
                        const data = doc.data();
                        updatedConversations.push({
                            id: doc.id,
                            name: data.name ? data.name : doc.id,
                        });
                    });

                    conversations = updatedConversations;

                    // If there's no activeConversation yet, set di first one
                    if (!$activeConversation && updatedConversations.length > 0) {
                        activeConversation.set(updatedConversations[0].id);
                        console.log("Default active conversation ID:", updatedConversations[0].id);
                    }
                },
                (error) => {
                    console.error("Error fetching conversations:", error);
                }
            );
    }
}

async function startNewConversation() {
    console.log("Starting a new conversation");
    //console.log("User ID:", $userID);
    //console.log("Client User ID:", $clientUserID);

    if (!$userID || !$clientUserID) {
        console.error("Invalid $userID or $clientUserID", $userID, $clientUserID);
        return;
    }

    const conversationId = generateRandomId(5);
    //console.log("Generated Conversation ID:", conversationId);

    const conversationRef = $db.collection('users').doc($userID)
                                .collection('deploymentUserData').doc($clientUserID)
                                .collection("clientSubUsers").doc($emailHash)
                                .collection('conversations').doc(conversationId);

    //console.log("Conversation Reference:", conversationRef.path);

    const timestamp = firebase.firestore.FieldValue.serverTimestamp();
    const messageData = {
        message: { "role": "system", "content": "You are a helpful assistant." },
        timestamp: timestamp
    };

    const conversationData = {
        timestamp: timestamp,
        lastModified: timestamp,
        name: "New Conversation"
    };

    try {
//        console.log("Setting conversation data");
        await conversationRef.set(conversationData);
  //      console.log("Conversation data set successfully");

    //    console.log("Adding initial message");
        await conversationRef.collection('messages').add(messageData);
      //  console.log("Initial message added successfully");

        // Set the newly created conversation as active
        activeConversation.set(conversationId);
     //   console.log("Active conversation set");

        fetchConversations();
    } catch (error) {
        console.error("Error starting new conversation:", error);
    }
}


</script>

<button class={`${extraClass}`} on:click={() => startNewConversation()}>
    New Chat
</button>


<style>
        .new-chat-button {
        flex: 3; /* Takes 75% of the space */
        margin-right: 8.5px; /* Optional: adds some space between the buttons */
        border: 1px solid #4D4D4F;
        border-radius: 6px;
        color: var(--sidebarconvodiv-text);
        background-color: var(--sidebar-bg);
        cursor: pointer;
    }
</style>